var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCm0063(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6601 2C20.0601 2 22.0001 3.92 22.0001 7.33V16.67C22.0001 20.06 20.0701 22 16.6701 22H7.33012C3.92012 22 2.00012 20.06 2.00012 16.67V7.33C2.00012 3.92 3.92012 2 7.33012 2H16.6601ZM11.9901 7.51C11.5301 7.51 11.1601 7.88 11.1601 8.34V11.16H8.33012C8.11012 11.16 7.90012 11.25 7.74012 11.4C7.59012 11.56 7.50012 11.769 7.50012 11.99C7.50012 12.45 7.87012 12.82 8.33012 12.83H11.1601V15.66C11.1601 16.12 11.5301 16.49 11.9901 16.49C12.4501 16.49 12.8201 16.12 12.8201 15.66V12.83H15.6601C16.1201 12.82 16.4901 12.45 16.4901 11.99C16.4901 11.53 16.1201 11.16 15.6601 11.16H12.8201V8.34C12.8201 7.88 12.4501 7.51 11.9901 7.51Z",
    fill: "#605BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCm0063);
export default __webpack_public_path__ + "static/media/Plus_cm0063.01a2e2a1d4b3a9f393495de51fd872be.svg";
export { ForwardRef as ReactComponent };